import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAvatarImage = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: inherit;\n  object-fit: cover;\n  width: inherit;\n"])));

var AvatarImage = function AvatarImage(props) {
  return /*#__PURE__*/_jsx(StyledAvatarImage, _objectSpread({
    "data-testid": "avatar-image"
  }, props));
};

AvatarImage.displayName = "AvatarImage";
AvatarImage.propTypes = {
  /** Accessibility measurement for verbal image description */
  alt: PropTypes.node,

  /** Path to image file */
  src: PropTypes.string,

  /** Defines multiple sizes of the same image, allowing the browser to select the appropriate image source */
  srcset: PropTypes.string
};
AvatarImage.defaultProps = {
  alt: '',
  src: undefined,
  srcset: ''
};
export { AvatarImage };